import { AlpineComponentTryba } from '../../scripts/alpine/include/global';
import { activateAbTestByEvent } from '../../scripts/ab/registry';

// AB test 86c5m05un - Link to quotation form with prefilled steps
export default (): AlpineComponentTryba => ({
    init() {
        window.addEventListener('optin-and-consent-quotation', () => {
            activateAbTestByEvent('optin-and-consent-quotation');
            this.$store.ab.optinAndConsentQuotationState = true;
        });
    },
});
